import React, {useState} from "react";
import Page from "./Page";
import {Breadcrumbs} from "./Breadcrumbs";
import {invokeDAGviaApiPost} from "../../Api/invokeDag";
import ButtonLoader from "../../utils/components/ButtonLoader";
import AirflowDagLogs from "./airflow/dagLogs/AirflowDagLogs";
import {makeApiCall} from "../../Api/makeApiCall";
import {getUserEmail} from "../../auth/accessTokenValidator";
import IfpsMappingsUsageLog from "../Services/IfpsMappingsUsageLog";

export function isValidGCSLocation(outputLocation) {
    return Boolean(outputLocation && (outputLocation.startsWith('gs://') || outputLocation.startsWith('gcs://')));
}

export function isValidFileExtension(outputLocation) {
    return Boolean(outputLocation && outputLocation.endsWith('.jsonl'));
}

export const IFPSService = () => {
    const incomingIfpsLocation = "gs://curvball/prod/produce_plu/prod_produce_plu_produce_plu_ifps_snapshot.csv"
    const [ifpsOutputLocation, setIfpsOutputLocation] = useState(`gs://${process.env.REACT_APP_GCS_DATA_BASE_URL}/p_data=plu/ifps.jsonl`);
    const [errors, setErrors] = useState([]);

    const DAG_ID_TO_TRIGGER = "convert_plu_to_json"
    const IFPS_ALIAS_MAPPINGS_ENDPOINT = `${process.env.REACT_APP_EDP_API_BASE_URL}/syncIfpsAliasMapping`;

    const dagData = {
        input_path: incomingIfpsLocation,
        output_path: ifpsOutputLocation
    }

    function validateOutputLocation(outputLocation) {
        const errors = [
            {
                valid: isValidFileExtension(outputLocation),
                message: "The file must have a .jsonl extension"
            },
            {
                valid: isValidGCSLocation(outputLocation),
                message: "The output location must be a valid GCS location"
            }
        ].filter(e => !e.valid);

        setErrors(errors);
    }

    return (
        <Page breadCrumbs={<Breadcrumbs items={[{label: "Services"}, {label: "Produce"}, {label: "IFPS Service"}]}/>} name={'IFPS Service'} beta>
            <div className={'ifps-dag-trigger-group'}>
                <div className={'ifps-dag-action-buttons-container'}>
                    <div className={'ifps-dag-column'}>
                        <div className={'ifps-dag-selection-row'}>
                            <div className={'ifps-dag-inputs'}>
                                <span className='input-group-label span-height'>IFPS Source Location:</span>
                                <input
                                    id={'ifps-source-input'}
                                    data-testid={'ifps-source-input'}
                                    className={'input-group-field ifps-source-input'}
                                    type='text'
                                    value={incomingIfpsLocation}
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className={'ifps-dag-selection-row'}>
                            <div className={'ifps-dag-inputs'}>
                                <span className='input-group-label span-height'>IFPS Output Location:</span>
                                <input
                                    id={'ifps-output-input'}
                                    data-testid={'ifps-output-input'}
                                    className={'input-group-field ifps-output-input'}
                                    type='text'
                                    value={ifpsOutputLocation || ''}
                                    onChange={(e) => {
                                        setIfpsOutputLocation(e.target.value);
                                        validateOutputLocation(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className={'ifps-dag-selection-row'}>
                            <div className={'ifps-dag-errors'}>
                                {errors && errors.map(e => {
                                    return (<span>{e.message}</span>)
                                })}
                            </div>
                        </div>
                    </div>
                    <div className={'ifps-dag-column'}>
                        <div className={'ifps-dag-trigger-dag-row'}>
                            <ButtonLoader
                                buttonTitle={"Trigger IFPS DAG"}
                                buttonHasModal
                                disabled={errors.length !== 0}
                                buttonClassName={"button primary ifps-service-dag-submit"}
                                modalText={"Are you sure you want to run the IFPS DAG?"}
                                axiosFunction={() => invokeDAGviaApiPost(DAG_ID_TO_TRIGGER, dagData)}
                                toastTextFailure={"IFPS DAG failed to start."}
                                toastTextSuccess={"IFPS DAG started successfully."}
                            />
                        </div>
                    </div>

                    <div className={'ifps-dag-column'}>
                        <div className={'ifps-dag-trigger-dag-row'}>
                            <ButtonLoader
                                buttonTitle={"Sync ifps alias mapping"}
                                buttonHasModal
                                disabled={errors.length !== 0}
                                buttonClassName={"button primary ifps-alias-mapping-submit"}
                                modalText={"Are you sure you want to sync the ifps alias mappings?"}
                                axiosFunction={() => makeApiCall(`${IFPS_ALIAS_MAPPINGS_ENDPOINT}/?triggeredBy=${getUserEmail()}`)}
                                toastTextFailure={"ifps alias mapping failed to sync."}
                                toastTextSuccess={"ifps alias mapping sync successful."}
                            />
                        </div>
                    </div>

                </div>
            </div>
            <spsn>Ifps Mapping Sync</spsn>
            <>
                <IfpsMappingsUsageLog/>
            </>
            <spsn>Ifps Dag Run</spsn>
            <AirflowDagLogs
                processName={DAG_ID_TO_TRIGGER}
                includeDagName={false}
                customColumns={[
                    {header: 'Input Path', accessorKey: 'conf.input_path', className: 'non-numeric-field'},
                    {header: 'Output Path', accessorKey: 'conf.output_path', className: 'non-numeric-field'},
                ]}
            />
        </Page>
    )
}